/**
 * @file Contém as constantes do usuario
 */
 const usuario = {
    ORIGEM_LOGIN_AD: 'AD',
    ROLES: {
        ADMINISTRADOR: 'ADMINISTRADOR',
        ADMINISTRADOR_PARAMS: 'ADMINISTRADOR_PARAMS',
        SUPERADMINISTRADOR: 'SUPERADMINISTRADOR',
        CONSULTA: 'CONSULTA',
        ADMINISTRADOR_RF: 'ADMINISTRADOR_RF',
    }
}
export default usuario;
